const MAX_RECENT_CLIENTS = 8;

export function buildRecentlyViewed(
  id,
  name,
  email,
  mobilePhone,
  store,
  store_code,
  safety_alert,
  appointment
) {
  return {
    id: id,
    name: name,
    email: email,
    mobilePhone: mobilePhone,
    store: store,
    store_code: store_code,
    safety_alert: safety_alert,
    appointment: appointment,
    is_recent: true
  };
}

export function addRecentlyViewed(client) {
  let recents = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  recents = recents.filter(recent => recent.id !== client.id);

  recents.unshift(client);

  if (recents.length > MAX_RECENT_CLIENTS) {
    recents.pop();
  }

  localStorage.setItem('recentlyViewed', JSON.stringify(recents));
}

export function getRecentlyViewed() {
  return JSON.parse(localStorage.getItem('recentlyViewed')) || [];
}
